const defaultLocale = "it"

const i18nPath = {
  it: {
    category: "categoria",
    search: "cerca",
    products: "prodotti",
  },
  en: {
    category: "category",
    search: "search",
    products: "products",
  },
  "en-US": {
    category: "category",
    search: "search",
    products: "products",
  },
}

export function getPagePath(page, locale) {
  const pageLocale = locale || page.locale
  let lang =
    pageLocale === defaultLocale ? "/" : `/${pageLocale.toLowerCase()}/`
  let path = `${page._allSlugLocales.find(x => x.locale === pageLocale).value}`
  if (page.root) {
    return lang + `${path}/`
  }

  path = `${
    page.treeParent._allSlugLocales.find(x => x.locale === pageLocale).value
  }/${path}`
  if (page.treeParent.root) {
    return lang + `${path}/`
  }
  path = `${
    page.treeParent.treeParent._allSlugLocales.find(
      x => x.locale === pageLocale
    ).value
  }${path}`
  return lang + `${path}/`
}

export function getLandingPagePath(page, locale) {
  return locale === defaultLocale
    ? `/${page._allSlugLocales.find(x => x.locale === locale).value}/`
    : `/${locale.toLowerCase()}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getHomePath(locale) {
  return locale === defaultLocale ? "/" : `/${locale.toLowerCase()}/`
}

export function getSearchPath(locale) {
  return locale === defaultLocale
    ? `/${i18nPath[locale].search}/`
    : `/${locale.toLowerCase()}/${i18nPath[locale].search}/`
}

export function getNewsPath(locale) {
  return locale === defaultLocale ? `/news/` : `/${locale.toLowerCase()}/news/`
}

export function getReferencesPath(locale) {
  return locale === defaultLocale
    ? `/referenze/`
    : `/${locale.toLowerCase()}/news/`
}

export function getArticleCategoryPath(page, locale) {
  return locale === defaultLocale
    ? `/news/${i18nPath[locale].category}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
    : `/${locale.toLowerCase()}/news/${i18nPath[locale].category}/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getCategoryFamilyPath(page, locale) {
  return page.locale === defaultLocale
    ? `/${page.slug}/`
    : `/${page.locale.toLowerCase()}/${page.slug}/`
}

export function getCategoryPath(page, locale, productFamily) {
  let familyCategories = JSON.parse(JSON.stringify(productFamily.nodes))

  let foundCategoryParent = familyCategories.filter(familyCategory => {
    let foundParent = familyCategory.categories.filter(categories => {
      let tmpCat = JSON.parse(JSON.stringify(categories))
      let tmpPage = JSON.parse(JSON.stringify(page))
      return tmpCat.id === tmpPage.id
    })
    if (foundParent.length > 0) return familyCategory
  })[0]

  return page.locale === defaultLocale
    ? `/${foundCategoryParent.slug}/${page.slug}/`
    : `/${page.locale}/${i18nPath[page.locale].category}/${page.slug}/`
}

export function getArticlePath(page, locale) {
  return locale === defaultLocale
    ? `/news/${page._allSlugLocales.find(x => x.locale === locale).value}/`
    : `/${locale.toLowerCase()}/news/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getSectorPath(page, locale) {
  return locale === defaultLocale
    ? `/settore/${page._allSlugLocales.find(x => x.locale === locale).value}`
    : `/${locale.toLowerCase()}/settore/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}
export function getServicePath(page, locale) {
  return locale === defaultLocale
    ? `/servizi/${page._allSlugLocales.find(x => x.locale === locale).value}/`
    : `/${locale.toLowerCase()}/servizi/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getReferencePath(page, locale) {
  return locale === defaultLocale
    ? `/referenze/${page._allSlugLocales.find(x => x.locale === locale).value}/`
    : `/${locale.toLowerCase()}/referenze/${
        page._allSlugLocales.find(x => x.locale === locale).value
      }/`
}

export function getProductPath(page, locale, parentFamily, parentCategory) {
  let familyCategories = JSON.parse(JSON.stringify(parentFamily))
  let categories = JSON.parse(JSON.stringify(parentCategory))
  let foundCategoryParent = null

  let foundProductCategory = categories.nodes.filter(category => {
    let foundParent = category.products.filter(product => {
      return (
        JSON.parse(JSON.stringify(product)).id ===
        JSON.parse(JSON.stringify(page)).id
      )
    })
    if (foundParent.length > 0) return category
  })[0]

  if (foundProductCategory)
    foundCategoryParent = familyCategories.nodes.filter(familyCategory => {
      let foundParent = familyCategory.categories.filter(categories => {
        return (
          JSON.parse(JSON.stringify(categories)).id ===
          JSON.parse(JSON.stringify(foundProductCategory)).id
        )
      })
      if (foundParent.length > 0) return familyCategory
    })[0]

  if (foundProductCategory && foundCategoryParent)
    return locale === defaultLocale
      ? `/${foundCategoryParent.slug}/${foundProductCategory.slug}/${page.slug}/`
      : `/${locale.toLowerCase()}/${i18nPath[page.locale].products}/${
          page.slug
        }/`
  else return `/${page.slug}/`
}
